module.exports = __webpack_public_path__ + "img/profil_lapper_ana-lucila.bbea8baa.png";